import { render } from "./partnerdetail.vue?vue&type=template&id=ce146b14&scoped=true"
import script from "./partnerdetail.vue?vue&type=script&lang=js"
export * from "./partnerdetail.vue?vue&type=script&lang=js"

import "./partnerdetail.vue?vue&type=style&index=0&id=ce146b14&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce146b14"]])

export default __exports__